import { redirect } from '@tanstack/react-router'

import { DASHBOARD_PATH } from '@/features/group/post-login-path'
import { isWebViewSession } from '@/lib/webview-session'

import { isAuthenticated } from './store'

export function publicEntryPath() {
  return isAuthenticated() ? DASHBOARD_PATH : unauthenticatedPath()
}

export function unauthenticatedPath() {
  return isWebViewSession() ? '/app-session-required' : '/login'
}

export function redirectAuthenticated() {
  if (isAuthenticated()) throw redirect({ to: DASHBOARD_PATH, replace: true })
  if (isWebViewSession()) throw redirect({ to: '/app-session-required', replace: true })
}

export function requireAuthentication() {
  if (!isAuthenticated()) throw redirect({ to: unauthenticatedPath(), replace: true })
}
